const RENTALS_DISCOUNTS = {
  //getFirstMinuteDiscount
  RENTALS_FIRST_MINUTE_DISCOUNT: 'RENTALS_FIRST_MINUTE_DISCOUNT',
  //getLastMinuteDiscount
  RENTALS_LAST_MINUTE_DISCOUNT: 'RENTALS_LAST_MINUTE_DISCOUNT',
  //getLongerStayDiscount
  RENTALS_LONGER_STAY_DISCOUNT: 'RENTALS_LONGER_STAY_DISCOUNT',
  //getPromotionDiscount
  RENTALS_PROMOTION_DISCOUNT: 'RENTALS_PROMOTION_DISCOUNT',
  //getFlexibleRuleDiscount
  RENTALS_FLEXIBLE_RULE_DISCOUNT: 'RENTALS_FLEXIBLE_RULE_DISCOUNT',
  //reorderDiscounts
  RENTALS_REORDER_DISCOUNTS: 'RENTALS_REORDER_DISCOUNTS',
};

export default RENTALS_DISCOUNTS;
